import {useQuery} from "@apollo/client";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {BillingDataResult, GQL_BILLING_DATA} from "@/lib/queries/billing.ts";

import AccountDetailsForm from "./AccountDetailsForm";
import SubaccountDetailsForm from "./SubaccountDetailsForm";

export const AccountDetailsPage = () => {
  const {user} = useCurrentUserContext();
  const {data: billingData} = useQuery<BillingDataResult>(GQL_BILLING_DATA);

  return (
    <ContentContainer title="Account Details">
      <Helmet>
        <title>Account Details</title>
      </Helmet>
      <UpErrorBoundary>
        {user?.account &&
          billingData &&
          (user.account.is_subaccount ? (
            <SubaccountDetailsForm accountDetails={user.account} />
          ) : (
            <AccountDetailsForm accountDetails={user.account} billingData={billingData.billingData} />
          ))}
      </UpErrorBoundary>
    </ContentContainer>
  );
};

export default AccountDetailsPage;
